import React from 'react';
import VisiteGuidee from '../components/VisiteGuidee';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';

function App() {
  return (
    <div className="App">
      <VisiteGuidee />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
